import * as React from 'react';
import * as moment from 'moment';
import {connect} from "react-redux";
import {HISTORY_STATUS, itemsToBeChecked, USER_ROLE} from '../../Config/appConfig';
import {Auth, CoverNote} from '../../Config/dataModel';
import authState from '../../ReduxRequests/State/authState';
import util from '../../Util/util';
import '../../style/historyDropDown.css';

const collapse = require('../../resource/img/collapse-default.svg');

interface HistoryDropDownProps {
    auth?: () => Auth,
    history: CoverNote[]
}

interface HistoryDropDownState {
    expand: boolean;
}

class HistoryDropDown extends React.Component <HistoryDropDownProps, HistoryDropDownState> {
    public constructor(props: HistoryDropDownProps) {
        super(props);
        this.state = {
            expand: false,
        };
        this.clickExpand = this.clickExpand.bind(this);
    }

    public clickExpand(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        this.setState({
            expand: !this.state.expand
        });
    }

    public getChanges(status: string, prev: CoverNote, current: CoverNote) {
        let changes = [];
        if (status === HISTORY_STATUS.UPDATED) {
            let coverPeriodIncluded = false;
            for (let i = 0; i < itemsToBeChecked.length-1; i++) {
                const prevData = prev.state.data.props;
                const currentData = current.state.data.props;
                const itemValue = itemsToBeChecked[i].value;
                if (currentData[itemValue] !== prevData[itemValue]) {
                    let itemLabel = itemsToBeChecked[i].label;
                    let prevValue = prevData[itemValue];
                    let currentValue = currentData[itemValue];
                    if (i === 0) { itemLabel = `${util.getPolicyType(currentData.policyType)} ${itemLabel}`; }
                    else if (i === 2 || i === 3) {
                        if (!coverPeriodIncluded) {
                            coverPeriodIncluded = true;
                            const prevCoverPeriod = util.getDuration(moment(prevData.policyStartDate), moment(prevData.policyEndDate));
                            const currentCoverPeriod = util.getDuration(moment(currentData.policyStartDate), moment(currentData.policyEndDate));
                            if (prevCoverPeriod - currentCoverPeriod !== 0) { changes.push(`${itemsToBeChecked[4].label} from ${prevCoverPeriod} to ${currentCoverPeriod}`); }
                        }
                        prevValue = util.getFormattedDatetime(prevValue);
                        currentValue = util.getFormattedDatetime(currentValue);
                    }
                    changes.push(`${itemLabel} from ${prevValue === '' ? 'Nil' : prevValue} to ${currentValue === '' ? 'Nil' : currentValue}`);
                }
            }
        }
        else if (status === HISTORY_STATUS.VOIDED) { changes = [`Void Date ${util.getFormattedDate(current.state.data.props.policyVoidDate)}`]; }
        return changes;
    }

    public getHistory() {
        const history = [];
        let alreadyExpired = false;
        for (let i = 0; i < this.props.history.length; i++) {
            const data = this.props.history[i].state.data;
            const date = util.getFormattedDatetime(data.lastModifiedDate);
            const expired = moment(data.props.policyEndDate).isSameOrBefore(moment());
            const company = util.getHistoryCompanyName(data.requestedBy === USER_ROLE.INSURER ? data.props.insurerCode : data.props.subAgentCode, this.props.auth(), data.requestedBy);
            const status = util.getHistoryStatus(data.confirmationByInsurer, data.policyIssuedByInsurer, data.voidByParty, data.initialRequestDate, data.lastModifiedDate);
            const issueNo = data.props.policyReference;
            const policyType = util.getPolicyType(data.props.policyType);
            if (!expired) { alreadyExpired = false; }
            history.unshift(this.getContent(i, date, false, company, `${status} ${policyType}`, issueNo, this.getChanges(status, this.props.history[i-1], this.props.history[i])));
            if ((status === HISTORY_STATUS.CREATED && data.requestedBy === USER_ROLE.INSURER) || status === HISTORY_STATUS.ISSUED) {
               history.unshift(this.getContent(i+0.1, date, false, company, `${HISTORY_STATUS.CONFIRMED} ${policyType}`, issueNo, []));
            }
            if (expired && !alreadyExpired) {
                alreadyExpired = true;
                history.unshift(this.getContent(i+0.2, date, true, '', `${HISTORY_STATUS.EXPIRED} ${policyType}`, issueNo, []));
            }
        }
        return history;
    }

    public getContent(idx: number, date: string, expired: boolean, company: string, status: string, issueNo: string, changes: object[]) {
        const updates = [];
        if (changes.length) {
            for (let i = 0; i < changes.length; i++) {
                updates.push(
                    <div key={i} className="cmVerCenter historyDropDownSmallTitle">{changes[i]}</div>
                );
            }
        }
        const invalid = status.includes(HISTORY_STATUS.EXPIRED) || status.includes(HISTORY_STATUS.VOIDED);
        return (
            <div key={idx} className={`historyDropDownRecordContainer ${invalid ? 'historyDropDownRecordInvalid' : 'historyDropDownRecordValid'}`}>
                <div className="cmVerCenter historyDropDownRecordDate">{date}</div>
                <div className="cmText cmVerCenter">
                    {!expired && <div className="historyDropDownSmallTitle">{company}</div>}
                    <div>{`${status} (${issueNo})`}</div>
                    {updates}
                </div>
            </div>
        );
    }

    public render() {
        return (
            <div className="noPrint">
                <button className="cmInput historyDropDownBtn" onClick={this.clickExpand}>
                    <div>History</div>
                    <img className={this.state.expand ? "" : "cmCollapse"} src={collapse}/>
                </button>
                {this.state.expand && <div className="cmInput">{this.getHistory()}</div>}
            </div>
        );
    }
}

export default connect<any, any, HistoryDropDownProps>(authState, null)(HistoryDropDown);



// WEBPACK FOOTER //
// ./src/Components/Custom/HistoryDropDown.tsx